/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Proof_Felix_RoamInputs */

const fr_free_proof_felix_roam = /** @type {(inputs: Free_Proof_Felix_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation du nouveau mot de passe`)
};

/**

* @param {Free_Proof_Felix_RoamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_proof_felix_roam = /** @type {((inputs?: Free_Proof_Felix_RoamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Proof_Felix_RoamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_proof_felix_roam(inputs)
});